export default __webpack_public_path__ + "static/partner3-610c4fe7b82117bcdf03ced458fa1fe4.jpg";